<template>
    <div>
        <div  v-if="checkTime && timeForm.status=='0'" style="width: 50%;text-align: center;margin: auto;margin-top: 30px;padding: 20px">
            <el-card class="box-card" v-if="status==0">
                <div class="text item">
                    <h2 style="letter-spacing:20px;color: red">未开始录取</h2>
                </div>
            </el-card>
            <el-card class="box-card" v-else-if="status==2">
                <div slot="header" class="clearfix">
                    <h2 style="letter-spacing:20px;">录取通知书</h2>
                </div>
                <div class="text item" style="letter-spacing:5px;">
                    <p style="text-align: left"><span style="font-size: 20px;font-weight: bold">{{name}}</span>同学:</p>
                    <p style="text-align: left;margin-left: 25px">你已被我校<span style="font-size: 20px;font-weight: bold">{{major}}</span>专业录取。实际以通知书为准。</p>
                    <p style="text-align: left;margin-left: 25px;font-size: 14px;color: #ff3510">注:学校将继续对录取考生进行资格审查，如有发现不符条件审查不通过的，将取消录取资格。</p>
                </div>
            </el-card>
            <el-card class="box-card" v-else-if="status==4">
                <div class="text item">
                    <h2 style="letter-spacing:20px;color: red">未录取</h2>
                </div>
            </el-card>
        </div>
        <div v-else style="width: 600px;text-align: center;margin:auto;margin-top: 100px;">
            <el-card class="box-card" >
                <div slot="header" class="clearfix">
                    <span style="color: red">通知</span>
                </div>
                <div class="text item" style="color: red">
                    <p v-if="timeForm.status=='0'">未到查询录取时间({{timeForm.startTime}}~{{timeForm.endTime}})</p>
                    <p v-else>未到查询录取时间</p>
                    <p>暂无法查询录取情况。如有疑问请联系学院老师。</p>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysScoreLook",
        components: { noData },
        data() {
            return {
                status:'',
                name:'',
                major:'',
                ticketTime:'',
                checkTime:'',
                timeForm:{

                }
            }
        },
        created(){
        },
        mounted(){
            axios({
                url:`${home}/sysDdList/checkAdmissionTime`,
                method:'GET'
            }).then(res=>{
                this.timeForm = res.data;
                this.checkTime = res.data2;
                if(res.data2){
                    this.submit();
                }
            }).catch(error=>{

            })
        },
        methods: {
            submit(){
                axios({
                    url:`${home}/sysStudentAdmission/getStudentAdmissionByStuId`,
                    method:'GET',
                }).then(res=>{
                    this.status = res.data;
                    this.name = res.data2;
                    this.major = res.data3;
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>
